import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
import { Role } from "../User/Role";
export class Account extends HttpForm {
    data = {
        name: '',
        mail_from: null,
        endpoint: null,
        processor_endpoint: '',
        processor_client_id: null,
        processor_secret: null,
        processor_username: null,
        processor_password: null,
        simfoni_retail_endpoint: '',
        simfoni_retail_token: null,
        primary_color: '#BB6BD9',
        primary_lighter_percentage: 30,
        primary_darker_percentage: 20,
        secondary_color: '#f3f4f6',
        secondary_lighter_percentage: 30,
        secondary_darker_percentage: 20,
        tertiary_color: '#111827',
        tertiary_lighter_percentage: 30,
        tertiary_darker_percentage: 20,
        custom_css: null,
        upload_asset_logo: {
            uuid: null,
            key: null,
            bucket: null,
            file_name: null,
            content_type: null,
        },
        upload_asset_banner: {
            uuid: null,
            key: null,
            bucket: null,
            file_name: null,
            content_type: null,
        },
        upload_icon_one: {
            uuid: null,
            key: null,
            bucket: null,
            file_name: null,
            content_type: null,
        },
        upload_icon_two: {
            uuid: null,
            key: null,
            bucket: null,
            file_name: null,
            content_type: null,
        },
        pin_verification: false,
        active: true,
        terms: 'These are the terms and conditions',
        user_name: null,
        user_email: null,
        user_role: Role.GUEST,
        domains: [],
    };
    getSlug() {
        if (this.data.slug) {
            return this.data.slug;
        }
        return this.data.name.toLowerCase()
            .replace('\.', '')
            .replace(/[^a-z0-9]|\s+|\r?\n|\r/gmi, "-");
    }
    getPortalEndpoint() {
        let slug = this.getSlug();
        if (slug) {
            return 'https://' + this.getSlug() + '.' + window.location.hostname;
        }
        return null;
    }
    create() {
        const url = '/api/account';
        return axios.post(url, this.data)
            .then((account) => this.navigation.toRouteName('admin.account.manage', { slug: account.data.data.slug }))
            .catch(e => this.setError(e));
    }
    update() {
        const url = '/api/account/' + this.data.slug;
        return axios.patch(url, this.data)
            .then(() => this.navigation.toRouteName('admin.account.manage', { slug: this.data.slug }))
            .catch(e => this.setError(e));
    }
    getAccount(slug) {
        const url = '/api/account/' + slug;
        return axios.get(url)
            .then((response) => this.data = response.data.data)
            .catch(e => this.setError(e));
    }
    all() {
        const url = '/api/account/all';
        return axios.get(url).catch(e => this.setError(e));
    }
    addDomain() {
        this.data.domains.push({
            domain: '',
        });
    }
    removeDomain(key) {
        let domains = this.data.domains;
        this.data.domains = domains.filter(function (value, index) {
            return key !== index;
        });
    }
}
